export const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'Our Care', to: '/our-care' },
  { label: 'Life Here', to: '/life-here' },
  { label: 'Visit & Contact', to: '/visit' },
];